<template>
    <ion-page>
        <base-layout>
            <ion-card>
                <ion-card-content>
                    <ion-text>
                        <div class="ion-text-center mb-15">
                            <strong>{{ $t('configLoadErrorInformation') }}</strong>
                        </div>
                    </ion-text>
                    <div class="ion-text-center">
                        <ion-button type="button" @click="reloadApp();" class="ion-text-center">{{ $t('tryAgain') }}</ion-button>
                    </div>
                </ion-card-content>
            </ion-card>
        </base-layout>
    </ion-page>
</template>

<script>
import {IonPage, IonCard, IonCardContent, IonText, IonButton} from '@ionic/vue';
import BaseLayout from '../components/base/BaseLayout.vue';

export default {
    components: {IonPage, BaseLayout, IonCard, IonCardContent, IonText, IonButton},

    methods: {
        reloadApp() {
            location.href = '/';
        }
    }
}
</script>